import styled from 'styled-components';
import { theme } from '../../../theme';

const { colors } = theme;

export const DivWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-gap: 30px;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
`;

export const DivItem = styled.div`
  margin-bottom: 1.5rem;

  button {
    text-align: left;
  }
`;

export const DivTitle = styled.div`
  margin-bottom: 1.3rem;
  font-size: 1.078rem;
  font-weight: 600;
  color: ${colors.textDeaccent};
`;

export const H4Subtitle = styled.h4`
  // To rewrite native h4 styles
  font-weight: 600 !important;
  font-size: 1.077rem !important;
  line-height: 17px !important;
`;

export const DivFileslistWrapper = styled.div`
  margin: 0 0 1rem 1rem;
`;

export const H5PrinterTitle = styled.h5`
  margin-bottom: 1rem;
`;
